import { createTheme, ThemeOptions } from "@mui/material/styles";

const themeOptions: ThemeOptions = {
  shape: {
    borderRadius: 14,
  },
  palette: {
    primary: {
      main: "#D65A88",
      light: "#E989AD",
      dark: "#B6436F",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#7061DA",
      light: "#9A8FF0",
      dark: "#4F42AF",
      contrastText: "#FFFFFF",
    },
    background: {
      default: "#FFFFFF",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#2B252B",
      secondary: "#6F6672",
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 700,
      fontSize: "3rem",
      lineHeight: 1.12,
      letterSpacing: "0.02em",
    },
    h2: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 600,
      fontSize: "2.25rem",
      lineHeight: 1.16,
      letterSpacing: "0.02em",
    },
    h3: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 600,
      fontSize: "1.85rem",
      lineHeight: 1.2,
    },
    h4: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 600,
      fontSize: "1.45rem",
      lineHeight: 1.24,
    },
    h5: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 600,
      fontSize: "1.18rem",
      lineHeight: 1.28,
    },
    h6: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 600,
      fontSize: "1.02rem",
      lineHeight: 1.34,
    },
    body1: {
      fontSize: "0.98rem",
      lineHeight: 1.68,
    },
    body2: {
      fontSize: "0.9rem",
      lineHeight: 1.6,
    },
    button: {
      textTransform: "none",
      fontWeight: 600,
      letterSpacing: "0.02em",
    },
    subtitle1: {
      fontSize: "0.82rem",
      fontWeight: 600,
      letterSpacing: "0.14em",
      textTransform: "uppercase",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          paddingInline: 22,
          paddingBlock: 10,
          textTransform: "none",
          boxShadow: "none",
        },
        contained: {
          boxShadow: "0 10px 24px rgba(214, 90, 136, 0.22)",
          "&:hover": {
            boxShadow: "0 12px 26px rgba(214, 90, 136, 0.3)",
          },
        },
        outlined: {
          borderWidth: 1.5,
          "&:hover": {
            borderWidth: 1.5,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 18,
          border: "1px solid rgba(36, 24, 38, 0.06)",
          boxShadow: "0 12px 34px rgba(25, 18, 30, 0.06)",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 18,
          border: "1px solid rgba(36, 24, 38, 0.06)",
          boxShadow: "0 12px 34px rgba(25, 18, 30, 0.06)",
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        html: { margin: 0, padding: 0 },
        body: { margin: 0, padding: 0, backgroundColor: "#fff" },
        "#root": { margin: 0, padding: 0 },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          border: "none",
          borderRadius: 0,
          boxShadow: "none",
        },
        colorPrimary: {
          background: "#FFFFFF",
          color: "#2B252B",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 999,
        },
      },
    },
  },
};

export const theme = createTheme(themeOptions);
